module.exports = {
    hosts: 'https://save.ltdhunt.com https://api.save.ltdhunt.com https://www.google.com https://www.gstatic.com '+(process.env.SENTRY_RELEASE ? 'https://*.sentry.io https://sentry.io' : '')
}